import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template.[appTemplateType]',
})
export class TemplateTypeDirective {

  @Input() appTemplateType: string;

  constructor(public templateRef: TemplateRef<any>) { }

}
